<div mat-dialog-content *ngIf="select.url">
    <div id="videoPlayer">
        <iframe [src]="select.url | vimeoUrl"
            style=" width: 100%;height: 285px; border: 1px solid #eee; border-radius: 4px;" frameborder="0"
            webkitallowfullscreen mozallowfullscreen allowfullscreen allow="autoplay">
        </iframe>
    </div>
</div>
<span class="ms-4 txt-btm">{{select.vid_name}}</span>